import $ from "jquery";
import { core } from "../framework/core";
import { dateFormatter } from "../framework/dateFormatter";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";

let baseUrl;
let loaForCommercialSupportTypeName;
function init(url, showspinner, spinnerWait, loaUploadTypeNameParam) {
    this.baseUrl = url;
    this.loaUploadTypeName = loaUploadTypeNameParam;
    core.init();
    dateFormatter.init();
    dataaccess.setShowSpinner(showspinner);
    forms.setSpinnerWait(spinnerWait);

    $("[mask]").each(function(idx, item) {
        $(item).mask($(item).attr("mask"));
    });

    $("[data-toggle='tooltip']").tooltip();

    // Prevents tooltip from staying visible whenever it has focus, such as after closing a modal that was opened by tooltip button
    $("[rel='tooltip']").tooltip({ trigger: "hover" }).on("click", function() {
        $(this).tooltip("hide");
    });

    $("#log-out").click(function() {
        clearSessionStorage();
    });

    // When working with modal overlays (multiple open modals), if you have a modal that exceeds the
    // browser height, then you can't vertical scroll when closing an second modal. This fixes the issue.
    $(document).on("hidden.bs.modal", ".modal", function () {
        $(".modal:visible").length && $(document.body).addClass("modal-open");
    });
}

function clearSessionStorage() {
    if (typeof (Storage) !== "undefined") {
        sessionStorage.clear();
    }
}

function loadOneModule(module) {
    core.loadOneModule(module);
}

export const application = {
    init: init,
    clearSessionStorage: clearSessionStorage,
    loadOneModule: loadOneModule,
    baseUrl: baseUrl,
    loaForCommercialSupportTypeName: loaForCommercialSupportTypeName
};